import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function deleteAssetFromBriefcase({ coinId, stockRuId } = {}) {
  const param = coinId ? `coin_id=${coinId}` : `stock_ru_id=${stockRuId}`;
  const url = `${backendUrl}/api/widgets/user-assets/?${param}`;

  try {
    const response = await fetchWithAuth(url, { method: 'DELETE' });
    if (!response.ok) {
      throw new Error(`Network error: HTTP ${response.status}`);
    }
    return true;
  } catch (error) {
    console.error('API deleteAssetFromBriefcase error:', error);
    throw error;
  }
}
